import { render, staticRenderFns } from "./LbCorpolateBtn.vue?vue&type=template&id=00fb0492&"
import script from "./LbCorpolateBtn.vue?vue&type=script&lang=js&"
export * from "./LbCorpolateBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports